/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCronjobRunSummaryDto } from '../models/work-cronjob-run-summary-dto';
import { WorkCronjobTimelineDto } from '../models/work-cronjob-timeline-dto';

@Injectable({ providedIn: 'root' })
export class WorkCronjobRunsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `cronjobRunsV2ControllerGetSummary()` */
  static readonly CronjobRunsV2ControllerGetSummaryPath = '/v2/admin/cronjob-runs/summary';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cronjobRunsV2ControllerGetSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  cronjobRunsV2ControllerGetSummary$Response(
    params?: {

    /**
     * Anzahl Tage rückwärts ab jetzt (1–7)
     */
      days?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCronjobRunSummaryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCronjobRunsV2Service.CronjobRunsV2ControllerGetSummaryPath, 'get');
    if (params) {
      rb.query('days', params.days, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCronjobRunSummaryDto>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cronjobRunsV2ControllerGetSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cronjobRunsV2ControllerGetSummary(
    params?: {

    /**
     * Anzahl Tage rückwärts ab jetzt (1–7)
     */
      days?: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCronjobRunSummaryDto>> {
    return this.cronjobRunsV2ControllerGetSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCronjobRunSummaryDto>>): Array<WorkCronjobRunSummaryDto> => r.body)
    );
  }

  /** Path part for operation `cronjobRunsV2ControllerGetTimeline()` */
  static readonly CronjobRunsV2ControllerGetTimelinePath = '/v2/admin/cronjob-runs/timeline';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cronjobRunsV2ControllerGetTimeline()` instead.
   *
   * This method doesn't expect any request body.
   */
  cronjobRunsV2ControllerGetTimeline$Response(
    params: {

    /**
     * Tag im Format YYYY-MM-DD
     */
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCronjobTimelineDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCronjobRunsV2Service.CronjobRunsV2ControllerGetTimelinePath, 'get');
    if (params) {
      rb.query('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCronjobTimelineDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cronjobRunsV2ControllerGetTimeline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cronjobRunsV2ControllerGetTimeline(
    params: {

    /**
     * Tag im Format YYYY-MM-DD
     */
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkCronjobTimelineDto> {
    return this.cronjobRunsV2ControllerGetTimeline$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCronjobTimelineDto>): WorkCronjobTimelineDto => r.body)
    );
  }

}
